import React from 'react';

import { Newsletter } from '@utils/backend-api/newsletters';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './footerStyles.module.scss';

interface FooterProps {
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  gdpr: boolean;
  newsletter: Newsletter;
}

const Footer = ({
  currentUserAccessLevel,
  isLoggedIn,
  isSubscribed,
  gdpr,
  newsletter,
}: FooterProps) => {
  return (
    <div className={styles.feedNewsletterContainer} id="feed-newsletter-container-footer">
      <div className={styles.feedNewsletterWrapper}>
        <div className={styles.newsletterImageCard}>
          <img src={newsletter.cardImageUrl} role="presentation" />
        </div>
        <div className={styles.newsletterFormWrapper}>
          <div className={styles.frequency}>{newsletter.frequency}</div>
          <div className={styles.byline}>
            {newsletter.name} by {newsletter.author}
          </div>
          <div className={styles.description}>{newsletter.description}</div>
          <NewsletterSignUp
            buttonSize="small"
            currentUserAccessLevel={currentUserAccessLevel}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={gdpr}
            newsletter={newsletter}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
